import React, {useState} from "react";
import UsageTableSection from "./usageTableSection";
import ComponentHeader from "../CommonComponents/componentHeader";
import SlidingTab from "../CommonComponents/slidingTab";
import MonthSelector from "../Usage/monthSelector";
import ThirdPartyTableSection from "./thirdPartyTableSection";

const BILLING_COMPONENT = "BILLING_COMPONENT";

const BillingPageWrapper = () => {
    const [selectedInd, setSelectedInd] = useState(0);

    const getChildren = () => {
        switch (selectedInd) {
            case 0:
                return <UsageTableSection/>;

            case 1:
                return <ThirdPartyTableSection/>;

            default:
                return <UsageTableSection/>;
        }
    }

    return (
        <>
            <ComponentHeader title={"Billing"}/>
            <div className="mt-0">
                <SlidingTab menuArr={["In-house", "Third-party"]} selectedInd={selectedInd} setIndex={setSelectedInd} children={getChildren()} sibling={<></>}/>
            </div>
        </>
    )
}

export default BillingPageWrapper;
export {BILLING_COMPONENT};
